<div class="row">
    <div class="col-lg-12">
        <div class="">
            <header class="col-xs-11 text-center" *ngIf="step1Error?.hasErrorFlag">
                <h2 class="has-error">
                    <span class="help-block">
                        <em>*</em> {{step1Error?.errorMessage}}
                    </span>
                </h2>
            </header>
            <div class="col-xs-12 px-0">
                <div class="main-box clearfix">
                    <div class="main-box-body clearfix pb-0">
                        <h2 class="requisition-description-heading my-4 pl-2 font-bold">Basic Details</h2>
                        <form role="form" novalidate>
                            <div class="row">
                                <div class="col-lg-11">
                                    <div class="form-group col-xs-3"
                                        *ngIf="userDetails?.company?.companyType === MESSAGECONSTANTS.COMPANY_TYPES.STAFFING || userDetails?.company?.companyType === MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE"
                                        [class.has-error]="isClientOrBuRequired || (step1Error?.hasErrorFlag && clientOrBuIsRequiredFlag && !req.clientOrBU?.id)">
                                        <label for="client">
                                            Belongs to
                                        </label>
                                        <em> * </em> :
                                        <select name="client"
                                                id="client"
                                                [value]="req.clientOrBU?.id"
                                                (change)="onClientIdChange($event.target.value)"
                                                class="form-control access"
                                                [disabled]="isClientOrBuDisabled"
                                                [required]="clientOrBuIsRequiredFlag">
                                            <option *ngIf="clientOrBuIsRequiredFlag && !req.clientOrBU?.id" value="" disabled selected>Select</option>
                                            <option *ngFor="let client of clientOrBuList; trackBy: trackById"
                                                [value]="client.id">{{client.displayName}}</option>
                                        </select>
                                    </div>
                                    <!-- Bu/Corp -->
                                    <div class="form-group col-xs-offset-1 col-xs-3"
                                        *ngIf="userDetails?.company?.companyType === MESSAGECONSTANTS.COMPANY_TYPES.STAFFING && (req.isSharedClientRequisition || (req.sharedClientBuOrCorpId !== null && req.sharedClientBuOrCorpId !== undefined)) && !isLoadingSharedClientBus"
                                        [class.has-error]="step1Error?.hasErrorFlag && !sharedClientBuOrCorp?.id">
                                        <label for="sharedClientBuOrCorp">
                                            <span>Client's Bus</span>
                                            <em> * </em> :
                                        </label>
                                        <select class="form-control" name="sharedClientBuOrCorp" id="sharedClientBuOrCorp"
                                                [value]="sharedClientBuOrCorp?.id"
                                                (change)="onSharedClientBuOrCorpChange($event.target.value)"
                                                [disabled]="isClientOrBuDisabled"
                                                required>
                                            <option *ngIf="!sharedClientBuOrCorp?.id" value="" disabled selected>Select</option>
                                            <option *ngFor="let bu of sharedClientBus" [value]="bu.id">{{bu.name}}</option>
                                        </select>
                                    </div>
                                    <div class="col-xs-offset-1 col-xs-4 text-center" style="position: relative;top: 28px;"
                                        *ngIf="userDetails?.company?.companyType === MESSAGECONSTANTS.COMPANY_TYPES.STAFFING && (req.isSharedClientRequisition || req.sharedClientBuOrCorpId !== null) && isLoadingSharedClientBus">
                                        <div class="skeleton-container d-inline-block" style="width: 150px;">
                                            <div class="skeleton-paragraph width-100 skeleton-loading my-0"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="form-group col-xs-12 pl-4 ml-1" [hidden]="editModeFlag || !isUploadAndEditRadioBtn">
                                    <div class="upload-req-radio" style="display: inline;">
                                        <input type="radio" name="addRequisitionType" id="uploadRequisition"
                                            [value]="true" [checked]="isUploadRequisition === true" (change)="onUploadRequisitionTypeChange(true)">
                                        <label for="uploadRequisition">
                                            Upload Job Description
                                        </label>
                                    </div>
                                    <div class="upload-req-radio" style="display: inline;">
                                        <input type="radio" name="addRequisitionType" id="enterRequisitionDetails" [value]="false"
                                            [checked]="isUploadRequisition === false" (change)="onUploadRequisitionTypeChange(false)">
                                        <label for="enterRequisitionDetails">
                                            Enter Job Description
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="main-box-body clearfix col-lg-12 pl-2" *ngIf="isUploadRequisition">
                            <div class="col-xs-6">
                                <form style="min-height: 0px;" name="reqUploadDropzone" id="reqUploadDropzone" class="p-0 dropzone dz-clickable" action="" enctype="multipart/form-data"
                                    [dropzone]="dropzoneConfig" (addedFile)="onReqUploadFileAdded($event)"
                                    (removedFile)="onReqUploadFileRemoved($event)"
                                    (sending)="onReqUploadFileSending($event)"
                                    (success)="onReqUploadFileSuccess($event)"
                                    (error)="onReqUploadFileError($event)">
                                    <div class="dz-a dz-default dz-message my-2">
                                        <span>
                                            <h3>Drop file here to upload</h3>(or click)
                                        </span>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <!-- Upload Requisition button -->
                        <div class="row buttonrow" style="margin-bottom: 200px" *ngIf="isUploadRequisition">
                            <div class="col-xs-6 d-flex justify-content-center">
                                <button type="button" class="btn btn-success col-xs-4" id="uploadFile" (click)="uploadRequisitionCallback.emit()" [disabled]="disableUploadButtonFlag || currentJobStatus == 'OPEN'">
                                    <i class="fa fa-upload mr-2"></i>
                                    <span *ngIf="!fileUploadInProgressFlag">Upload </span><span *ngIf="fileUploadInProgressFlag">Uploading... </span> Requisition
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!isUploadRequisition && isJobFetched && !isLoading">
                <app-requisition-skills
                    *ngIf="!requisitionSkillsLoading"
                    [isSharedReq]="false"
                    [currentJobStatus]="currentJobStatus"
                    [isUploadRequisition]="isUploadRequisition"
                    [jobTitle]="job.title"
                    [jobLocation]="job.locationLabel"
                    (updateLocationCallback)="updateLocationCallback.emit()"
                    (showJobProfileCallback)="showJobProfileCallback.emit()"
                    [allExistingSkills]="allExistingSkills"
                    [allExistingDegrees]="allExistingDegrees"
                    [allExistingFieldOfStudy]="allExistingFieldOfStudy"
                    [allExistingRoles]="allExistingRoles"
                    [allExistingCertificates]="allExistingCertificates"
                    [allExistingJDActionWords]="allExistingJDActionWords"
                    [timePeriods]="timePeriods"
                    [skillsTimePeriods]="skillsTimePeriods"
                    [profileCriteriaInfo]="job.profileCriteriaInfo"
                    [includeCandidateAdditionalDetails]="job.includeCandidatesWithNoAdditionalDetails"
                    [includeCandidatesMatchingMandatoryCriteria]="job.includeCandidatesMatchingMandatoryCriteria"
                    [stepOneHasError]="step1Error?.hasErrorFlag"
                    (updateJobTitleCallback)="job.title = $event"
                    (updateIncludeCandidateDetailsCallback)="job.includeCandidatesWithNoAdditionalDetails = $event"
                    (updateIncludeCandidateMatchingMandatoryCriteriaCallback)="job.includeCandidatesMatchingMandatoryCriteria = $event">
                </app-requisition-skills>
            </div>
        </div>
    </div>
</div>
